import { render, staticRenderFns } from "./RevisionPanel.vue?vue&type=template&id=2739c5fb&"
import script from "./RevisionPanel.vue?vue&type=script&lang=ts&"
export * from "./RevisionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./RevisionPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports